// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__2mV5p","on":"style_on__2T-fa","large":"style_large__2UbrT","odds":"style_odds__1uq1_"};